import { withStyles } from "@material-ui/core";
import classNames from "classnames";
import React from "react";

const ValorPropaganda = ({ classes, label, valor, unidade, riscado }) => {
  return (
    <div className={classes.container}>
      <span className={classes.label}>{label}</span>
      <div className={classes.content}>
        <div className={classes.contentValor}>
          {riscado && (
            <>
              <span className={classNames(classes.linha, classes.linha1)} />
              <span className={classNames(classes.linha, classes.linha2)} />
            </>
          )}
          {valor}
        </div>
        <p className={classes.unidade}>{unidade}</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  label: {
    fontWeight: "bold",
  },
  content: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    flexDirection: 'column',
  },
  contentValor: {
    position: "relative",
    borderRadius: "6px",
    background: "#219A97",
    color: "#fff",
    textAlign: "center",
    fontSize: "32px",
    fontWeight: "bold",
    width: "100%",
  },
  linha: {
    position: "absolute",
    top: "50%",
    left: 0,
    width: "100%",
    height: "3px",
    background: "orange",
    borderRadius: "2px",
    opacity: 0.9,
  },
  linha1: {
    transform: "rotate(10deg)",
  },
  linha2: {
    transform: "rotate(-10deg)",
  },
  unidade: {
    fontSize: "12px",
    color: "#555",
    margin: 0,
  },
};

export default withStyles(styles)(ValorPropaganda);
